module.exports = __webpack_public_path__ + "static/media/Ripple-2.7s-211px.3b69700f.gif";